import script from "./LeagueMatchStandingsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueMatchStandingsView.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueMatchStandingsView.vue?vue&type=style&index=0&id=1aaef78c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aaef78c"]])

export default __exports__